// GENERATED by scripts/build-art-groups.js. Do not edit by hand.
//
// Printings whose illustration differs from their card's booster art. Keyed by
// artwork base (the variant slug minus its finish suffix) so the standard and
// foil printings of one illustration share an entry; the value is the group id,
// which is the earliest artwork base in the group. Any base absent from this
// map belongs to the card's default group, ART_GROUP_BASE.
//
// Derived from the card images themselves. See the script header for why the
// product code and the artist field both get this wrong.

export const ALT_ART_GROUP_BY_SLUG_BASE = {
  'alp-critical_strike-bt': 'alp-critical_strike-bt',
  'alp-sirian_templar-bt': 'alp-sirian_templar-bt',
  'art-rubble-bt': 'art-rubble-bt',
  'bet-courtesan_thais-b': 'bet-courtesan_thais-b',
  'bet-death_dealer-b': 'bet-death_dealer-b',
  'bet-ruler_of_thul-b': 'bet-ruler_of_thul-b',
  'bet-vile_imp-b': 'bet-vile_imp-b',
  'got-harbinger-pd': 'got-harbinger-pd',
  'got-necromancer-pd': 'got-necromancer-pd',
  'got-persecutor-pd': 'got-persecutor-pd',
  'got-rubble-bt': 'got-rubble-bt',
  'got-savior-pd': 'got-savior-pd',
  'got-skeleton-bt': 'got-skeleton-bt',
  'pro-amazon_warriors-ai': 'pro-amazon_warriors-ai',
  'pro-apprentice_wizard-wk': 'pro-apprentice_wizard-wk',
  'pro-bone_rabble-op': 'pro-bone_rabble-op',
  'pro-briar_patch-d': 'pro-briar_patch-d',
  'pro-camelot-d': 'pro-camelot-d',
  'pro-city_of_glass-scg': 'pro-city_of_glass-scg',
  'pro-cloud_city-d': 'pro-cloud_city-d',
  'pro-dark_tower-op': 'pro-dark_tower-op',
  'pro-day_of_judgment-op': 'pro-day_of_judgment-op',
  'pro-dispel-op': 'pro-dispel-op',
  'pro-fields_of_phyxis-d': 'pro-fields_of_phyxis-d',
  'pro-foot_soldier_1-d': 'pro-foot_soldier_1-d',
  'pro-foot_soldier_2-d': 'pro-foot_soldier_2-d',
  'pro-foot_soldier_3-d': 'pro-foot_soldier_3-d',
  'pro-gothic_tower-op': 'pro-gothic_tower-op',
  'pro-grandmaster_wizard-wk': 'pro-grandmaster_wizard-wk',
  'pro-guile_sirens-k': 'pro-guile_sirens-k',
  'pro-haystack-d': 'pro-haystack-d',
  'pro-headless_haunt-op': 'pro-headless_haunt-op',
  'pro-king_arthur-d': 'pro-king_arthur-d',
  'pro-lightning_bolt-tc': 'pro-lightning_bolt-tc',
  'pro-lone_tower-op': 'pro-lone_tower-op',
  'pro-occult_ritual-k': 'pro-occult_ritual-k',
  'pro-pudge_butcher-d': 'pro-pudge_butcher-d',
  'pro-river_of_blood-d': 'pro-river_of_blood-d',
  'pro-sir_lancelot-tc': 'pro-sir_lancelot-tc',
  'pro-skeleton-ai': 'pro-skeleton-ai',
  'pro-sorcerer-d': 'pro-sorcerer-k',
  'pro-sorcerer-k': 'pro-sorcerer-k',
  'pro-sorcerer-op': 'pro-sorcerer-op',
  'pro-swap-op': 'pro-swap-op',
  'pro-the_colour_out_of_space-d': 'pro-the_colour_out_of_space-d',
  'pro-war_horse-d': 'pro-war_horse-d',
  'pro-waypoint_portal-d': 'pro-waypoint_portal-d',
  'pro-witch-ai': 'pro-witch-ai',
  'pro-witherwing_hero-ai': 'pro-witherwing_hero-ai',
};

// Which card each alt-art group belongs to, and the set + product it printed
// in. cardId is the catalog id (NOT derivable from the slug. See cardIdFor in
// the generator); artGroupLabel() turns the set + product into the tile
// subtitle that tells two arts of one card apart.
export const ALT_ART_GROUP_META = {
  'alp-critical_strike-bt': { cardId: 'sorcery-critical_strike', card: "Critical Strike", set: "Alpha", product: 'Box_Topper' },
  'alp-sirian_templar-bt': { cardId: 'sorcery-sirian_templar', card: "Sirian Templar", set: "Alpha", product: 'Box_Topper' },
  'art-rubble-bt': { cardId: 'sorcery-rubble', card: "Rubble", set: "Arthurian Legends", product: 'Box_Topper' },
  'bet-courtesan_thais-b': { cardId: 'sorcery-courtesan_tha_s', card: "Courtesan Thaïs", set: "Beta", product: 'Booster' },
  'bet-death_dealer-b': { cardId: 'sorcery-death_dealer', card: "Death Dealer", set: "Beta", product: 'Booster' },
  'bet-ruler_of_thul-b': { cardId: 'sorcery-ruler_of_thul', card: "Ruler of Thul", set: "Beta", product: 'Booster' },
  'bet-vile_imp-b': { cardId: 'sorcery-vile_imp', card: "Vile Imp", set: "Beta", product: 'Booster' },
  'got-harbinger-pd': { cardId: 'sorcery-harbinger', card: "Harbinger", set: "Gothic", product: 'Preconstructed_Deck' },
  'got-necromancer-pd': { cardId: 'sorcery-necromancer', card: "Necromancer", set: "Gothic", product: 'Preconstructed_Deck' },
  'got-persecutor-pd': { cardId: 'sorcery-persecutor', card: "Persecutor", set: "Gothic", product: 'Preconstructed_Deck' },
  'got-rubble-bt': { cardId: 'sorcery-rubble', card: "Rubble", set: "Gothic", product: 'Box_Topper' },
  'got-savior-pd': { cardId: 'sorcery-savior', card: "Savior", set: "Gothic", product: 'Preconstructed_Deck' },
  'got-skeleton-bt': { cardId: 'sorcery-skeleton', card: "Skeleton", set: "Gothic", product: 'Box_Topper' },
  'pro-amazon_warriors-ai': { cardId: 'sorcery-amazon_warriors', card: "Amazon Warriors", set: "Promotional", product: 'Alpha_Investments' },
  'pro-apprentice_wizard-wk': { cardId: 'sorcery-apprentice_wizard', card: "Apprentice Wizard", set: "Promotional", product: 'Welcome_Kit' },
  'pro-bone_rabble-op': { cardId: 'sorcery-bone_rabble', card: "Bone Rabble", set: "Promotional", product: 'Organized_Play' },
  'pro-briar_patch-d': { cardId: 'sorcery-briar_patch', card: "Briar Patch", set: "Promotional", product: 'Dust' },
  'pro-camelot-d': { cardId: 'sorcery-camelot', card: "Camelot", set: "Promotional", product: 'Dust' },
  'pro-city_of_glass-scg': { cardId: 'sorcery-city_of_glass', card: "City of Glass", set: "Promotional", product: 'Star_City_Games' },
  'pro-cloud_city-d': { cardId: 'sorcery-cloud_city', card: "Cloud City", set: "Promotional", product: 'Dust' },
  'pro-dark_tower-op': { cardId: 'sorcery-dark_tower', card: "Dark Tower", set: "Promotional", product: 'Organized_Play' },
  'pro-day_of_judgment-op': { cardId: 'sorcery-day_of_judgment', card: "Day of Judgment", set: "Promotional", product: 'Organized_Play' },
  'pro-dispel-op': { cardId: 'sorcery-dispel', card: "Dispel", set: "Promotional", product: 'Organized_Play' },
  'pro-fields_of_phyxis-d': { cardId: 'sorcery-fields_of_phyxis', card: "Fields of Phyxis", set: "Promotional", product: 'Dust' },
  'pro-foot_soldier_1-d': { cardId: 'sorcery-foot_soldier_1', card: "Foot Soldier 1", set: "Promotional", product: 'Dust' },
  'pro-foot_soldier_2-d': { cardId: 'sorcery-foot_soldier_2', card: "Foot Soldier 2", set: "Promotional", product: 'Dust' },
  'pro-foot_soldier_3-d': { cardId: 'sorcery-foot_soldier_3', card: "Foot Soldier 3", set: "Promotional", product: 'Dust' },
  'pro-gothic_tower-op': { cardId: 'sorcery-gothic_tower', card: "Gothic Tower", set: "Promotional", product: 'Organized_Play' },
  'pro-grandmaster_wizard-wk': { cardId: 'sorcery-grandmaster_wizard', card: "Grandmaster Wizard", set: "Promotional", product: 'Welcome_Kit' },
  'pro-guile_sirens-k': { cardId: 'sorcery-guile_sirens', card: "Guile Sirens", set: "Promotional", product: 'Kickstarter' },
  'pro-haystack-d': { cardId: 'sorcery-haystack', card: "Haystack", set: "Promotional", product: 'Dust' },
  'pro-headless_haunt-op': { cardId: 'sorcery-headless_haunt', card: "Headless Haunt", set: "Promotional", product: 'Organized_Play' },
  'pro-king_arthur-d': { cardId: 'sorcery-king_arthur', card: "King Arthur", set: "Promotional", product: 'Dust' },
  'pro-lightning_bolt-tc': { cardId: 'sorcery-lightning_bolt', card: "Lightning Bolt", set: "Promotional", product: 'Team_Covenant' },
  'pro-lone_tower-op': { cardId: 'sorcery-lone_tower', card: "Lone Tower", set: "Promotional", product: 'Organized_Play' },
  'pro-occult_ritual-k': { cardId: 'sorcery-occult_ritual', card: "Occult Ritual", set: "Promotional", product: 'Kickstarter' },
  'pro-pudge_butcher-d': { cardId: 'sorcery-pudge_butcher', card: "Pudge Butcher", set: "Promotional", product: 'Dust' },
  'pro-river_of_blood-d': { cardId: 'sorcery-river_of_blood', card: "River of Blood", set: "Promotional", product: 'Dust' },
  'pro-sir_lancelot-tc': { cardId: 'sorcery-sir_lancelot', card: "Sir Lancelot", set: "Promotional", product: 'Team_Covenant' },
  'pro-skeleton-ai': { cardId: 'sorcery-skeleton', card: "Skeleton", set: "Promotional", product: 'Alpha_Investments' },
  'pro-sorcerer-k': { cardId: 'sorcery-sorcerer', card: "Sorcerer", set: "Promotional", product: 'Kickstarter' },
  'pro-sorcerer-op': { cardId: 'sorcery-sorcerer', card: "Sorcerer", set: "Promotional", product: 'Organized_Play' },
  'pro-swap-op': { cardId: 'sorcery-swap', card: "Swap", set: "Promotional", product: 'Organized_Play' },
  'pro-the_colour_out_of_space-d': { cardId: 'sorcery-the_colour_out_of_space', card: "The Colour Out of Space", set: "Promotional", product: 'Dust' },
  'pro-war_horse-d': { cardId: 'sorcery-war_horse', card: "War Horse", set: "Promotional", product: 'Dust' },
  'pro-waypoint_portal-d': { cardId: 'sorcery-waypoint_portal', card: "Waypoint Portal", set: "Promotional", product: 'Dust' },
  'pro-witch-ai': { cardId: 'sorcery-witch', card: "Witch", set: "Promotional", product: 'Alpha_Investments' },
  'pro-witherwing_hero-ai': { cardId: 'sorcery-witherwing_hero', card: "Witherwing Hero", set: "Promotional", product: 'Alpha_Investments' },
};
